module.exports = __webpack_public_path__ + "img/6086b66465d799ab5705edec_vtex-1.5890cd69.svg";